export const func = {
    getDateTime(date) {
        if (!date) {
            return null
        }
        let parse = new Date(Date.parse(date))
        return parse.toLocaleString("en-US")
    },
}
